import { CALL_API } from 'Middlewares'
import {
    CORE_VERIFY_BYPASS_REQUEST,
    CORE_VERIFY_BYPASS_SUCCESS,
    CORE_VERIFY_BYPASS_FAILURE,

    CORE_VERIFY_LOGIN_REQUEST,
    CORE_VERIFY_LOGIN_SUCCESS,
    CORE_VERIFY_LOGIN_FAILURE,

    CORE_ACCEPT_TERM_REQUEST,
    CORE_ACCEPT_TERM_SUCCESS,
    CORE_ACCEPT_TERM_FAILURE,

    CORE_LOAD_USER_INFO_REQUEST,
    CORE_LOAD_USER_INFO_SUCCESS,
    CORE_LOAD_USER_INFO_FAILURE,

    CORE_LOAD_LAST_USERS_REQUEST,
    CORE_LOAD_LAST_USERS_SUCCESS,
    CORE_LOAD_LAST_USERS_FAILURE,

    CORE_SEND_REPORT_REQUEST,
    CORE_SEND_REPORT_SUCCESS,
    CORE_SEND_REPORT_FAILURE,

    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE,

    CORE_CHANGE_PASSWORD_REQUEST,
    CORE_CHANGE_PASSWORD_SUCCESS,
    CORE_CHANGE_PASSWORD_FAILURE,

    CORE_FIRST_CHANGE_PASSWORD_REQUEST,
    CORE_FIRST_CHANGE_PASSWORD_SUCCESS,
    CORE_FIRST_CHANGE_PASSWORD_FAILURE,

    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST,
    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS,
    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE,
} from '../../types'

import { setToken, getAllToken, CORE_API_ENDPOINT, setIsAgree, clearBSRSToken, clearToken } from 'Lib'

import base64 from 'base-64'

export function findLastUsers() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/lastattendees`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_LAST_USERS_REQUEST,
                {
                    type: CORE_LOAD_LAST_USERS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return [json.value]
                                }
                            )
                    }
                },
                CORE_LOAD_LAST_USERS_FAILURE
            ]
        }
    }
}

export function changePassword(state, text, history) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/forgot/changepass/${text}`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ password: state.password, confirmPassword: state.password, code: state.code }),
            types: [
                CORE_CHANGE_PASSWORD_REQUEST,
                {
                    type: CORE_CHANGE_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    },
                    callBack() {
                        // window.location.replace('/login')
                        history.push(`/login`)
                    }
                },
                CORE_CHANGE_PASSWORD_FAILURE
            ]
        }
    }
}

export function requestChangePassword(email) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/resetpassword/${email}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
                {
                    type: CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE
            ]
        }
    }
}
export function finduserInfo() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/info/${getAllToken().user_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOAD_USER_INFO_REQUEST,
                {
                    type: CORE_LOAD_USER_INFO_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_LOAD_USER_INFO_FAILURE
            ]
        }
    }
}

export function loadVerifyBypass(id, email) {
    const decodeEmail = base64.decode(email)
    let data = {
        "id": id,
        "email": decodeEmail
    }
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/bypassverify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            types: [
                CORE_VERIFY_BYPASS_REQUEST,
                {
                    type: CORE_VERIFY_BYPASS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                const {
                                    token,
                                    expires_date_on,
                                    isAgreeTermAndCondition,
                                    data,
                                    role
                                } = json.value

                                const { fullName, userId, email, employeeId, isExecutive, isActive } = data
                                const tokens = {
                                    token,
                                    email,
                                    userId,
                                    expires_date_on,
                                    isAgreeTermAndCondition,
                                    employeeId,
                                    fullName,
                                    role,
                                    isExecutive,
                                    isActive
                                }

                                setToken(tokens)
                                return json.value
                            })
                    }
                },
                CORE_VERIFY_BYPASS_FAILURE,
            ]
        }
    }
}

export function loadVerifyLogin(email, password, history) {
    let data = {
        "email": email,
        "password": password,
    }
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/verify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            types: [
                CORE_VERIFY_LOGIN_REQUEST,
                {
                    type: CORE_VERIFY_LOGIN_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                const {
                                    token,
                                    expires_date_on,
                                    data,
                                } = json.value

                                const { fullName, role, userId, email, isExecutive, isAgreeTermAndCondition, isActive } = data
                                const tokens = {
                                    token,
                                    email,
                                    userId,
                                    expires_date_on,
                                    isAgreeTermAndCondition,
                                    fullName,
                                    role,
                                    isExecutive,
                                    isActive
                                }
                                setToken(tokens)
                                return json.value
                            })
                    }
                },
                CORE_VERIFY_LOGIN_FAILURE,
                {
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.error
                            })
                    }
                }
            ]
        }
    }
}

export function acceptTerm(history) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/agreetm`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            types: [
                CORE_ACCEPT_TERM_REQUEST,
                {
                    type: CORE_ACCEPT_TERM_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                setIsAgree()
                                return json.value
                            })
                    },
                    callBack() {
                        history.push("/")
                    }
                },
                CORE_ACCEPT_TERM_FAILURE,
            ]
        }
    }
}

export function sendReport(body) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/userreport`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            types: [
                CORE_SEND_REPORT_REQUEST,
                {
                    type: CORE_SEND_REPORT_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return [json.value]
                            })
                    },
                    // callBack() {
                    // }
                },
                CORE_SEND_REPORT_FAILURE,
            ]
        }
    }
}

export function firstChangePassword(state, history) {
    const { current, password, confirmPassword, accessToken } = state
    const body = {
        "code": current,
        "newPassword": password,
        "confirmPassword": confirmPassword
    }
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/changepass/code`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify(body),
            types: [
                CORE_FIRST_CHANGE_PASSWORD_REQUEST,
                {
                    type: CORE_FIRST_CHANGE_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                    callBack() {
                        clearBSRSToken()
                        clearToken()
                        // window.location.replace(`/login`)
                        history.push(`/login`)
                    }
                },
                CORE_FIRST_CHANGE_PASSWORD_FAILURE
            ]
        }
    }
}

export function sendEmailVerifyCode(accessToken, userId, isNew) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/changepass`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            types: [
                CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST,
                {
                    type: CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                    callBack() {
                        // clearBSRSToken()
                        clearBSRSToken()
                        clearToken()
                        if (isNew) {
                            window.location.replace(`/changepassword/${userId}?firsttime=true`)
                        }

                    }
                },
                CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/features/user/actions.js